exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "body{margin:0;padding:0;font-family:sans-serif}\n", "", {"version":3,"sources":["/home/benjam12/stkgarching/repository/website/src/client/app/index.css"],"names":[],"mappings":"AAAA,KAAK,SAAS,UAAU,sBAAsB,CAAC","file":"index.css","sourcesContent":["body{margin:0;padding:0;font-family:sans-serif}\n"],"sourceRoot":""}]);

// exports
